<div *ngIf="showButton" class="ai-chat-button-container">
    <button class="ai-chat-button" (click)="toggleChat()" [class.active]="isChatOpen" aria-label="Toggle AI Assistant"
        title="AI Care Coordinator Assistant">
      <span *ngIf="!isChatOpen" width="28" height="28" color="currentColor">Ai</span>

      <span *ngIf="isChatOpen" width="28" height="28" color="currentColor">Ai</span>
        <span class="pulse-ring"></span>
    </button>
</div>
